import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Card, Upload, Icon, Button, message } from 'antd'

import joinUsService from './../../services/joinus.service'
import recruitmentsService from './../../services/recruitments.service'

const FormItem = Form.Item

const JoinUsSupportingDocumentsStep = ({
  form,
  profile,
  handleFileUploads,
  handleFileDownload,
}) => {
  const { getFieldDecorator } = form
  const [files, setFiles] = useState(profile)
  const currentPath = window.location.pathname

  useEffect(() => {
    setFiles(profile)
  }, [profile])

  const curriculumVitaeUploadOptions = {
    name: 'Curriculum Vitae',
    openFileDialogOnClick: true,
    multiple: false,
    onChange(info) {
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        console.log('INFO', info)
        message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    async customRequest(options) {
      const recruitId = 'recruitId'

      if (!currentPath.includes('joinus')) {
        const fileCV = await recruitmentsService.uploadRecruitmentFile(
          options,
          recruitId,
          'fileCV'
        )

        handleFileUploads(fileCV, 'fileCV')
      } else {
        const fileCV = await joinUsService.uploadFile(
          options,
          recruitId,
          'fileCV'
        )

        handleFileUploads(fileCV, 'fileCV')
      }
    },
  }

  const coverLetterUploadOptions = {
    name: 'Cover Letter',
    openFileDialogOnClick: true,
    multiple: false,
    onChange(info) {
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        console.log('INFO', info)
        message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    async customRequest(options) {
      const recruitId = 'recruitId'

      if (!currentPath.includes('joinus')) {
        const fileCL = await recruitmentsService.uploadRecruitmentFile(
          options,
          recruitId,
          'fileCL'
        )

        handleFileUploads(fileCL, 'fileCL')
      } else {
        const fileCL = await joinUsService.uploadFile(
          options,
          recruitId,
          'fileCL'
        )

        handleFileUploads(fileCL, 'fileCL')
      }
    },
  }

  if (profile) {
    return (
      <Card title="Documents" type="inner">
        <Row>
          <Col span={24}>
            <FormItem
              label="Curriculum Vitae"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              {getFieldDecorator('fileCV', {
                valuePropName: 'file',
              })(
                <React.Fragment>
                  <Upload {...curriculumVitaeUploadOptions}>
                    <Button>
                      <Icon type="upload" /> Click to Upload
                    </Button>
                  </Upload>
                  <div
                    style={
                      files && files.fileCV
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {files && files.fileCV ? (
                      <a
                        href
                        onClick={() => {
                          handleFileDownload(
                            files.fileCV.originalname,
                            files.fileCV._id,
                            files.fileCV.fileType
                          )
                        }}
                      >
                        {files.fileCV.originalname}
                      </a>
                    ) : (
                      ''
                    )}
                  </div>
                </React.Fragment>
              )}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem
              label="Cover Letter"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              {getFieldDecorator('fileCL', {
                valuePropName: 'file',
              })(
                <React.Fragment>
                  <Upload {...coverLetterUploadOptions}>
                    <Button>
                      <Icon type="upload" /> Click to Upload
                    </Button>
                  </Upload>
                  <div
                    style={
                      files && files.fileCL
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {files && files.fileCL ? (
                      <a
                        href
                        onClick={() => {
                          handleFileDownload(
                            files.fileCL.originalname,
                            files.fileCL._id,
                            files.fileCL.fileType
                          )
                        }}
                      >
                        {files.fileCL.originalname}
                      </a>
                    ) : (
                      ''
                    )}
                  </div>
                </React.Fragment>
              )}
            </FormItem>
          </Col>
        </Row>
      </Card>
    )
  }

  return (
    <Card title="Documents" type="inner">
      <Row>
        <Col span={24}>
          <FormItem
            label="Curriculum Vitae"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            {getFieldDecorator('fileCV', {
              valuePropName: 'file',
            })(
              <React.Fragment>
                <Upload {...curriculumVitaeUploadOptions}>
                  <Button>
                    <Icon type="upload" /> Click to Upload
                  </Button>
                </Upload>
                <div
                  style={
                    files && files.fileCV
                      ? { display: 'block' }
                      : { display: 'none' }
                  }
                >
                  {files && files.fileCV ? (
                    <a
                      href
                      onClick={() => {
                        handleFileDownload(
                          files.fileCV.originalname,
                          files._id,
                          files.fileCV.fileType
                        )
                      }}
                    >
                      {files.fileCV.originalname}
                    </a>
                  ) : (
                    ''
                  )}
                </div>
              </React.Fragment>
            )}
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <FormItem
            label="Cover Letter"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            {getFieldDecorator('fileCL', {
              valuePropName: 'file',
            })(
              <React.Fragment>
                <Upload {...coverLetterUploadOptions}>
                  <Button>
                    <Icon type="upload" /> Click to Upload
                  </Button>
                </Upload>
                <div
                  style={
                    files && files.fileCL
                      ? { display: 'block' }
                      : { display: 'none' }
                  }
                >
                  {files && files.fileCL ? (
                    <a
                      href
                      onClick={() => {
                        handleFileDownload(
                          files.fileCL.originalname,
                          files._id,
                          files.fileCL.fileType
                        )
                      }}
                    >
                      {files.fileCL.originalname}
                    </a>
                  ) : (
                    ''
                  )}
                </div>
              </React.Fragment>
            )}
          </FormItem>
        </Col>
      </Row>
    </Card>
  )
}

export default JoinUsSupportingDocumentsStep
